import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-slate-300">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-8 md:grid-cols-3 lg:px-16 lg:py-20">
        <div>
          <img
            src="/logo-footer.png"
            alt="Zion Solutions — Entreprise générale du bâtiment"
            data-testid="footer-logo"
            className="w-60 max-w-full object-contain"
            loading="lazy"
          />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Rénovation de maisons et d’appartements à Genève.
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">Contact</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a
                href="tel:+41782135944"
                data-testid="footer-phone-link"
                className="flex items-center gap-3 transition-colors hover:text-white"
              >
                <Phone className="h-4 w-4 text-brand-light" strokeWidth={1.8} />
                +41 78 213 59 44
              </a>
            </li>
            <li>
              <a
                href="mailto:zionsolutions.ch@gmail.com"
                data-testid="footer-email-link"
                className="flex items-center gap-3 break-all transition-colors hover:text-white"
              >
                <Mail className="h-4 w-4 shrink-0 text-brand-light" strokeWidth={1.8} />
                zionsolutions.ch@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-brand-light" strokeWidth={1.8} />
              Genève et environs
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">
            Informations
          </p>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <button
                type="button"
                onClick={() => scrollToId("devis")}
                data-testid="footer-devis-link"
                className="transition-colors hover:text-white"
              >
                Demander un devis
              </button>
            </li>
            <li>
              <Link
                to="/mentions-legales"
                data-testid="footer-mentions-link"
                className="transition-colors hover:text-white"
              >
                Mentions légales
              </Link>
            </li>
            <li>
              <Link
                to="/politique-de-confidentialite"
                data-testid="footer-privacy-link"
                className="transition-colors hover:text-white"
              >
                Politique de confidentialité
              </Link>
            </li>
            <li>
              <Link
                to="/admin"
                data-testid="footer-admin-link"
                className="text-slate-500 transition-colors hover:text-white"
              >
                Espace pro
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-slate-500 sm:flex-row sm:px-8 lg:px-16">
          <p data-testid="footer-copyright">© 2026 Zion Solutions Suisse Sàrl — Genève</p>
          <p>Rénovation complète · Cuisines · Salles de bains · Finitions</p>
        </div>
      </div>
    </footer>
  );
};
